import React, { useState, useEffect, useRef, useContext } from 'react';

import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { MultiSelect } from 'primereact/multiselect';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';

import { getAreasAct } from '../../API/Global/Areas/AreasRequests';

import { AuthContext } from '../../Context/AuthContext/AuthContext';
import { formatNumberDecimal } from '../../Services/FormatTemplate';
import AgGrid from '../Tables/AgGrid/AgGrid';
import { toastShow } from '../../Services/ToastService';


const DividirItemArea = ({ detalles, CantidadDetalle = 0, selectedAreas, setSelectedAreas, setHabilitar, IdSubCategoria = null }) => {
    const toast = useRef(null)
    const [loading, setLoading] = useState(false);
    const [areas, setAreas] = useState([]);
    const [checkCantidad, setCheckCantidad] = useState(false);
    const [habilitarCheck, setHabilitarCheck] = useState(false);
    const [valorDividir, setValorDividir] = useState(0);
    const [agua, setAgua] = useState(false);
    const [puntosDeposito, setPuntosDeposito] = useState([])
    const [IdPuntoDeposito, setIdPuntoDeposito] = useState(0);
    const { userAuth } = useContext(AuthContext);

    const obtenerInformacion = async () => {
        setLoading(true)
        const tempoAreas = await getAreasAct()
        let a = tempoAreas.map((t, index) => {
            return {
                ...t,
                Id: index + 1
            }
        })
        setAreas(a)
        if (detalles?.length > 1) {
            setHabilitarCheck(false)
            setValorDividir(1)
        } else {

            setValorDividir(CantidadDetalle)
            if (IdSubCategoria === 110) { /// Id del servicio de agua embotellada

                // const tempoPuntos = await getPuntosDeposito()

                // setPuntosDeposito(tempoPuntos)
                setAgua(true)

            }
        }
        setLoading(false)
    }

    const asignarCantidadArea = (value) => {
        let nuevoArreglo = value
        let cantidadDivision = nuevoArreglo?.length

        nuevoArreglo.forEach(n => {
            n.CantidadArea = Number((valorDividir / cantidadDivision))
        });
        let cantidadTotalArea = nuevoArreglo?.reduce((total, value) => total + value.CantidadArea, 0)

        nuevoArreglo.forEach(n => {
            n.ProporcionArea = (1 / (cantidadTotalArea)) * n.CantidadArea
        });
        setSelectedAreas(nuevoArreglo)
    }

    const ProporcionArea = (data, valor) => {
        let dataArea = data
        let a = selectedAreas.filter((e) => e.Id !== dataArea.Id)
        let cantidadAreaRestante = a?.reduce((total, value) => total + value.CantidadArea, 0)
        let cantidadArea = a?.reduce((total, value) => total + value.CantidadArea, 0) + valor
        let tempo = [...selectedAreas]
        const index = tempo.findIndex(detail => detail.Id === dataArea.Id)
        tempo[index] = dataArea
        if (checkCantidad) {
            if ((cantidadAreaRestante + valor) > CantidadDetalle) {
                toastShow(toast, 'error', 'error', 'La cantidad por area no debe superar la cantidad total del detalle salida')
                let cantidadFaltante = CantidadDetalle - cantidadAreaRestante
                dataArea.CantidadArea = cantidadFaltante
            }
        } else {
            dataArea.CantidadArea = valor
        }
        if (checkCantidad) {
            let totalCantidad = tempo.reduce((total, value) => total + value.CantidadArea, 0)
            if (formatNumberDecimal(totalCantidad) !== formatNumberDecimal(CantidadDetalle)) {
                setHabilitar(true)
            } else {
                setHabilitar(false)
            }
        }

        tempo.forEach(n => {
            n.ProporcionArea = (1 / cantidadArea) * n.CantidadArea
        });

        setSelectedAreas(tempo)
    }

    const CambiarPuntosDeposito = async (value) => {
        // if (value > 0) {
        //     setIdPuntoDeposito(value)
        //     const result = await getPersonalAreasPuntosDeposito(value)

        //     if (result?.length > 0) {
        //         let cantidadTotal = result?.reduce((t, v) => t + v.Cantidad, 0)
        //         let detDeposito = []

        //         detDeposito = result?.map((r, index) => {
        //             return {
        //                 Id: index + 1,
        //                 IdArea: r.IdArea,
        //                 Area: r.Area,
        //                 CantidadArea: r.Cantidad,
        //                 IdMO: r.IdMO,
        //                 ProporcionArea: (1 / cantidadTotal) * r.Cantidad,
        //                 ManoObra: r.MO,
        //                 IdClasificacion: r.IdClasificacion,
        //                 // MemoDet: 'Consumo de agua embotellada para ' + r.Cantidad + ' empleados de ' + r.Area  
        //             }
        //         });

        //         setSelectedAreas(detDeposito)


        //     } else {
        //         setSelectedAreas(null)
        //         toastShow(toast, 'error', 'No se encuentran áreas para el punto de deposito seleccionado')
        //     }
        // }
    }

    const DistribucionTotal = () =>{
        let tempoAreas = areas.filter((a)=> a.IdClasificacion !== 6)
        asignarCantidadArea(tempoAreas)
    }

    const table = {
        Data: selectedAreas,
        Columns: [
            {
                field: 'Id',
                header: 'Id',
                headerEn: 'Id',
                className: 'Xsmall',
                hidden: userAuth.IdRol === 1,
                frozen: true,
                alignFrozen: 'left',
                width: 25
            },
            {
                field: 'Area',
                header: 'Area',
                className: 'XXlarge',
                Sumary: 'count',
                frozen: true,
                alignFrozen: 'left',
            },
            {
                field: 'CantidadArea',
                header: 'Cantidad',
                className: 'small',
                Format: 'Decimal',
                Sumary: 'sum',
                editable: true,
                onChange: (data) => {
                    if (data.newValue) {
                        ProporcionArea(data.data, data.newValue)
                    }
                },
            },
            {
                field: 'ManoObra',
                header: 'Mano Obra',
                headerEn: 'Mano Obra',
                className: 'Xsmall',
                hidden: IdSubCategoria === 110

            },

            {
                field: 'ProporcionArea',
                header: 'Proporcion',
                headerEn: 'Proporcion',
                className: 'small',
                Format: 'Currency',
                Sumary: 'sum'
            },
            // {
            //     field: 'IdArea',
            //     header: ' ',
            //     width: 50,
            //     frozen: true,
            //     alignFrozen: 'right',
            //     Format: 'Template',
            //     body: (data) => data.IdArea ?
            //         <div style={{ justifyContent: 'center', alignContent: 'center' }}>
            //             <Checkbox checked={data.IdArea ? true : false} onChange={(e) => removerArea(data)} />
            //         </div>
            //         : null


            // }

        ]
    }

    useEffect(() => {
        obtenerInformacion()
        setHabilitarCheck(!habilitarCheck)
        setAgua(false)
        setIdPuntoDeposito(null)
    }, [detalles])


    return (
        <div className='d-flex flex-row'>
            <Toast ref={toast} />
            <div className='d-flex flex-row'>
                {!agua ?

                    <div className='d-flex flex-column mx-2'>
                        <label htmlFor="Area">Áreas </label>

                        <MultiSelect value={selectedAreas} onChange={(e) => asignarCantidadArea(e.value)} options={areas} filter
                            optionLabel='Area' placeholder='Seleccione las Areas' maxSelectedLabels={1} className="w-full md:w-20rem"
                        />
                        <Button icon='ri-p2p-fill' label='Todas las Areas' className='my-2' onClick={()=> DistribucionTotal()} />


                    </div>

                    : <div className='pt-2 mx-2' style={{ width: '12vw' }}>
                        <span className="p-float-label">

                            <Dropdown
                                value={IdPuntoDeposito}
                                onChange={(e) => CambiarPuntosDeposito(e.value)}
                                options={puntosDeposito}
                                optionLabel='PuntoDeposito'
                                optionValue='IdDeposito'
                                filter filterBy='PuntoDeposito'
                                style={{ width: '12vw' }}

                            />
                            <label htmlFor="ms-cities">Puntos Deposito </label>
                        </span>
                    </div>

                }

                <div className='d-flex flex-column pt-2' style={{ height: '50vh', width: "42vw" }} id='DividirDetallesCXP'>
                    {habilitarCheck ?
                        <div>
                            <div>
                                <span className='mx-2'>Comentario: {detalles[0]?.ComentarioPOD} </span>
                            </div>
                            <div className='d-flex flex-row'>

                                <span className='mx-2'>Dividir áreas por cantidad : {formatNumberDecimal(CantidadDetalle)} </span>
                                <Checkbox checked={checkCantidad} onChange={(e) => setCheckCantidad(e.checked)} className='mx-2' disabled={!habilitarCheck} />
                            </div>

                        </div>

                        : null

                    }
                    <div id='DividirDetallesCXP' style={{ height: '50vh', width: "40vw" }}>
                        <AgGrid table={table} />
                    </div>
                    <span style={{ fontWeight: 'bold' }}>Cantidad de Áreas: {selectedAreas?.length}</span>

                </div>

            </div>
        </div>
    )
}

export default DividirItemArea
